// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import * as firebase from 'firebase'

import router from './router'
import Vuetify from 'vuetify'
import {
    store
} from './store'
import 'vuetify/dist/vuetify.min.css'

import Alert from './components/shared/alert.vue'
import Loader from './components/shared/loader.vue'
import EditText from './components/edit/edit'
import CreateText from './components/edit/createText'
import CreateSpot from './components/edit/createSpot'
import ReformText from './components/edit/reformText'
import TranslateText from './components/edit/translateText'

import EditPicture from './components/edit-pictures/editPicture'
import ReformPicture from './components/edit-pictures/reformPicture'
import TranslatePicture from './components/edit-pictures/translatePicture'
import CreatePicture from './components/edit-pictures/createPicture'

import EditQuestion from './components/edit-questions/edit-quest'
import ReformQuestion from './components/edit-questions/reformQuestion'
import TranslateQuestion from './components/edit-questions/translate-question'

import createQuestions from './components/edit-questions/createQuestions'

import DeleteText from './components/edit/deleteText'
import DeletePictures from './components/edit-pictures/deletePictures'
import DeleteQuestions from './components/edit-questions/deleteQuestions'

Vue.use(Vuetify)

Vue.config.productionTip = false;
Vue.component('alert', Alert);
Vue.component('loader', Loader);
Vue.component('edit-text', EditText);
Vue.component('edit-que', EditQuestion);
Vue.component('reform-que', ReformQuestion);
Vue.component('add-text', CreateText);
Vue.component('add-spot', CreateSpot);
Vue.component('reform-text', ReformText);
Vue.component('translate-text', TranslateText);
Vue.component('translate-que', TranslateQuestion);

Vue.component('edit-pic', EditPicture);
Vue.component('reform-pic', ReformPicture);
Vue.component('translate-pic', TranslatePicture);
Vue.component('create-pic', CreatePicture);

Vue.component('create-que', createQuestions);

Vue.component('delete-text', DeleteText);
Vue.component('delete-pic', DeletePictures);
Vue.component('delete-que', DeleteQuestions);
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>',
    created() {
        firebase.initializeApp({
            apiKey: "AIzaSyApD0-tURn2h0rm3Ju8HQJMzzgkDU_Sw9E",
            authDomain: "thimeledu.firebaseapp.com",
            databaseURL: "https://thimeledu.firebaseio.com",
            projectId: "thimeledu",
            storageBucket: "thimeledu.appspot.com",
            messagingSenderId: "886736881075"
        })
    }
})


// WEBPACK FOOTER //
// ./src/main.js